export function apiRequest() {
    return process.env.VUE_APP_API_BASE || "https://admin.guocode.com";
}
